import * as bootstrap from 'bootstrap'
import 'bootstrap'
import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/shear-and-moment-diagram.css'

import './components/nav-bar/nav-bar-component.js'
import './components/account/sign-up-modal-component.js'
import './components/account/finish-upgrade-modal-component.js'
import './components/account/login-modal-component.js'
import './components/account/forgot-password-modal-component.js'
import './components/account/logout-modal-component.js'

import './components/footer-component.js'
import './components/main-ui/material-and-shape-dialog-component.js'
import './components/main-ui/span-dialog-component.js'
import './components/main-ui/load-dialog-component.js'
import './components/main-ui/load-editor-dialog-component.js'

import { initializeApp } from 'firebase/app'
import { getAuth, browserLocalPersistence } from 'firebase/auth'
import { getDatabase, ref, get, set, update, remove, child, push } from 'firebase/database'

import {loadStripe} from '@stripe/stripe-js';

import { Beam } from './models/beam.js'
import { redrawCanvas } from './beam-view.js'
import { showResultCharts } from './results-view.js' 

const firebaseConfig = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
}

initializeApp(firebaseConfig)

const auth = getAuth()

let isUpgraded = false


var rtime = new Date(1, 1, 2000, 12, 0, 0);
var timeout = false;
var delta = 100;

function resizeend() {
  if (new Date() - rtime < delta) {
    setTimeout(resizeend, delta);
  } else {
    timeout = false;
    redrawCanvas(beam)
  }
}

window.addEventListener('resize', () => {
  rtime = new Date()
  if (timeout === false) {
    timeout = true;
    setTimeout(resizeend, delta);
  }
})

document.addEventListener('update-views', async () => {
  redrawCanvas(beam)
  document.dispatchEvent(new CustomEvent('update-span-table', { detail: beam }))
  document.dispatchEvent(new CustomEvent('update-load-table', { detail: beam }))
}, true)

// spans
document.addEventListener('update-span', async (event) => {
  beam.updateSpan(event.detail.index, event.detail.spanLength)
}, true)

document.addEventListener('add-left-span', async (event) => {
  if(beam.spans.length > 2 && isUpgraded === false) {
    alert("Span limit for the free version is 3. Upgrade to add more spans.");
  } else {
    beam.addLeftSpan(event.detail)
  }
}, true)

document.addEventListener('remove-span', async (event) => {
  beam.removeSpan(event.detail)
}, true)

document.addEventListener('add-right-span', async (event) => {
  if(beam.spans.length > 2 && isUpgraded === false) {
    alert("Span limit for the free version is 3. Upgrade to add more spans.");
  } else {
    beam.addRightSpan(event.detail)
  }
}, true)

// point loads
document.addEventListener('update-point-load', async (event) => {
  const detail = event.detail
  beam.updatePointLoad(detail.loadIndex, detail.x, detail.D, detail.isMoment)
}, true)

document.addEventListener('add-point-load', async (event) => {
  const detail = event.detail
  beam.addPointLoad(detail.x, detail.D, detail.isMoment)
}, true)

document.addEventListener('remove-point-load', async (event) => {
  beam.removePointLoad(event.detail)
}, true)

// dist loads
document.addEventListener('update-dist-load', async (event) => {
  const detail = event.detail
  beam.updateDistLoad(detail.loadIndex, detail.x1, detail.x2, detail.D, detail.D2, detail.isLinear)
}, true)

document.addEventListener('add-dist-load', async (event) => {
  const detail = event.detail
  beam.addDistLoad(detail.x1, detail.x2, detail.D, detail.D2, detail.isLinear)
}, true)

document.addEventListener('remove-dist-load', async (event) => {
  beam.removeDistLoad(event.detail)
}, true)

function onPrintProject() {
  if(featureGate()) { return }
  window.print()
}

document.getElementById('analyze-beam-button').onclick = analyzeBeam
document.getElementById('file-menu-print-file').onclick = onPrintProject

let beam = new Beam()
beam.addNode(0, 'pinned')
beam.addNode(144, 'pinned')
beam.addDistLoad(0, 144, 1000 / 12, 1000 / 12, false)
beam.addDistLoad(0, 144, 0, 1000 / 12, true)
beam.addPointLoad(72, 1000, false)
beam.addPointLoad(20, 1000 * 12, true)

const event = new CustomEvent('shear-moment-project-loaded', { detail: beam })
document.dispatchEvent(event)

function analyzeBeam() {

  const beamObj = JSON.stringify(beam);
  const shapeObj = JSON.stringify({Ix: beam.momentOfInertia, A: 1});
  const materialObj = JSON.stringify({E: beam.elasticModulus, Type: 'N/A'});

  const url = '/api/v1/shear-and-moment-diagram/solve/'
  fetch(url, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      beam: beamObj,
      shape: shapeObj,
      material: materialObj
    }),
  })
  .then(response => response.json())
  .then( (data) => {
    showResultCharts(data)
  })
  .catch((error) => {
    document.getElementById('api-error-div').classList.remove('d-none')
    document.getElementById('plot-panel-area').classList.add('d-none')
    console.error('Error:', error);
  })
}

function initializeFirebaseAuth() {

  auth.setPersistence(browserLocalPersistence)

  auth.onAuthStateChanged(function(user) {
    if (user) {
      const event = new CustomEvent('customer-logged-in', {detail: user});
      document.dispatchEvent(event)
      checkStripeSubscriptionAndConfigure()
    } else {
      // clear project list and reset the project
      configureLoggedOut()
    }
  })
}

initializeStripe()

async function checkStripeSubscriptionAndConfigure() {
  auth.currentUser.getIdToken().then(function(token) {
    fetch('https://us-central1-webstructrual.cloudfunctions.net/checkSubscription', {
      method: 'POST', 
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
    }).then((response) => {
      if(response.ok) {
        configureLoggedInAndUpgraded()      
      } else {
        configureLoggedInButNeedsUpgrade()
      }
    }).catch( (error) => {
      console.error(error)
      // error -> assume not subscribed
      configureLoggedInButNeedsUpgrade()
    })
  })
}

function configureLoggedInAndUpgraded() {
  isUpgraded = true
  const event = new CustomEvent('customer-logged-in-and-upgraded');
  document.dispatchEvent(event)
  
  document.getElementById('upgrade-now-to-unlock').classList.add('d-none')
  document.getElementById('almost-done-row').classList.add('d-none')
  document.getElementById('results').classList.remove('hidden-print')

  //getProjectsFromDatabaseAndUpdateProjectList()

  const dbRef = ref(getDatabase())
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((snapshot) => {
    if (snapshot.exists()) {
      if(snapshot.val().username) {
        document.getElementById('signed-in-as').innerHTML = snapshot.val().username        
      }
      if(snapshot.val().companyName) {
        //document.getElementById("your-company-name").innerHTML = snapshot.val().companyName
        //document.getElementById("company-name-header-settings-text-input").value = snapshot.val().companyName
      }
    } else {
      console.log("No data available")
    }
  }).catch((error) => {
    console.error(error)
  })
}

function configureLoggedInButNeedsUpgrade() {
  const event = new CustomEvent('customer-logged-in-not-upgraded');
  document.dispatchEvent(event)  
  
  document.getElementById('upgrade-now-to-unlock').classList.add('d-none')
  document.getElementById('almost-done-row').classList.remove('d-none')

  const dbRef = ref(getDatabase())
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((snapshot) => {
    if (snapshot.exists()) {
      if(snapshot.val().username) {
        document.getElementById('signed-in-as').innerHTML = snapshot.val().username + '<i class="fa fa-fw fa-info-circle text-danger"></i>'
      }
    } else {
      console.log("No data available")
    }
  }).catch((error) => {
    console.error(error)
  })
}

function configureLoggedOut() {
  isUpgraded = false
  let event = new CustomEvent('customer-logged-out')
  document.dispatchEvent(event)
      
  document.getElementById('almost-done-row').classList.add('d-none')
  document.getElementById('upgrade-now-to-unlock').classList.remove('d-none')
  document.getElementById('results').classList.add('hidden-print')
  projects = []

  //footingDesign = new FootingDesign()
  //event = new CustomEvent('project-loaded', {detail: footingDesign})
  //document.dispatchEvent(event)
}

initializeFirebaseAuth()

let projects = []

function featureGate() {
  if(auth.currentUser === null || !isUpgraded) {
    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-sign-up-form')).show()
    return true
  } else if(auth.current !== null && !isUpgraded) {
    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-finish-upgrade')).show()
    return true
  }
  return false
}

async function initializeStripe() {
  //const STRIPE_API_KEY='pk_test_oTBdaj3DiPoh2GN2LRP6bgzS'
  const STRIPE_API_KEY='pk_live_2xaQxOvCEelcE2SQvmCtWQac'
  const stripe = await loadStripe(STRIPE_API_KEY);
  //const stripe = await loadStripe(process.env.STRIPE_API_KEY);
  let elements = stripe.elements();

  // Custom styling can be passed to options when creating an Element.
  var style = {
    base: {
      // Add your base input styles here. For example:
      fontSize: '20px',
      color: "#32325d",
    }
  };

  if (typeof elements === 'undefined') {
      console.error("unable to create Stripe Card in initializeStripe(). elements undefined")
      return;
  }
  
  // Create an instance of the card Element.
  var card = elements.create('card', {style: style});

  if (typeof card === 'undefined') {
      console.error("unable to create Stripe Card in initializeStripe(). card undefined")
      return;
  }

  // Add an instance of the card Element into the `card-element` <div>.
  card.mount('#card-element');

  card.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
          displayError.textContent = event.error.message;
      } else {
          displayError.textContent = '';
      }
  });

  // Create a token or display an error when the form is submitted.
  var form = document.getElementById('payment-form');
  form.addEventListener('click', function(event) {
      event.preventDefault();
      stripe.createToken(card).then(function(result) {
          if (result.error) {
              // Inform the customer that there was an error.
              var errorElement = document.getElementById('card-errors');
              errorElement.textContent = result.error.message;
              console.error(result.error.message);
          } else {
              // Send the token to your server.
              stripeTokenHandler(result.token);
              //console.log(result.token);
          }
      });
  });
}

function stripeTokenHandler(token) {
  document.getElementById('submit-payment-spinner').classList.remove('d-none')
  document.getElementById('submit-payment-button').disabled = true

  var form = document.getElementById('payment-form');
  var hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'stripeToken');
  hiddenInput.setAttribute('value', token.id);
  form.appendChild(hiddenInput);

  var user = auth.currentUser;
  var uid = user.uid;
  var email = user.email;
  var tok = token.id;
  var card = token.card.id;

  var dict = {uid: uid, email: email, token: tok, card: card};

  auth.currentUser.getIdToken().then(function(token) {
    fetch('https://us-central1-webstructrual.cloudfunctions.net/subscription', {
      method: 'POST', 
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(dict)
    }).then((response) => {
      //console.log(response.ok)
      document.getElementById('submit-payment-spinner').classList.add('d-none')
      document.getElementById('submit-payment-button').disabled = false
      document.getElementById('subscribe-response-error').classList.add('d-none')
      document.getElementById('subscribe-response-error').innerHTML = ''
      checkStripeSubscriptionAndConfigure()
    }).catch( (error) => {
      document.getElementById('submit-payment-spinner').classList.add('d-none')
      document.getElementById('submit-payment-button').disabled = false
      document.getElementById('subscribe-response-error').classList.remove('d-none')
      document.getElementById('subscribe-response-error').innerHTML = error
    })
  })
}


